import axios from 'axios'
import apiConfigDetails from '../../config/api.config.json'
import { hashKey, getTzOffset, ivConstant } from './AESEncrypt'
import packageJson from '../../../package.json'

import curlirize from 'axios-curlirize';

let { REACT_APP_NAME = 'servifyInd', REACT_APP_ENV = 'development' } = process.env


const apiConfig = apiConfigDetails[REACT_APP_NAME][REACT_APP_ENV]

export const apiInstance = axios.create({
 baseURL: `${apiConfig.uri}`,
})

export const apiCoreInstance = axios.create({
 baseURL: `${apiConfig["core"].uri}`,
})

curlirize(apiInstance);

apiInstance.interceptors.request.use((config) => {
 config.headers['App'] = "Servify-TradeInLead-Web"
 config.headers['Accept'] = 'application/json text/plain, */*'
 config.headers['Content-Type'] = 'application/json'
 config.headers['dr9se2q'] = hashKey({ tzU: new Date().getTime(), appC: '4T2E5RTVX5' })
 config.headers['co1cx2'] = ivConstant()
 config.headers['countrycode'] = 'IN'
 config.headers['countryid'] = '105'
 config.headers['AppVersion'] = packageJson.version;
 const accessToken = localStorage.getItem('ampleAccessToken')
 if (accessToken) {
  config.headers['Authorization'] = accessToken
 }
 return config
})

apiCoreInstance.interceptors.request.use((config) => {
 config.headers['App'] = "Servify-TradeInLead-Web"
 config.headers['Accept'] = 'application/json text/plain, */*'
 config.headers['Content-Type'] = 'application/json'
 config.headers['dr9se2q'] = hashKey({ tzU: new Date().getTime(), appC: '4T2E5RTVX5' })
 config.headers['co1cx2'] = ivConstant()
 config.headers['countrycode'] = 'IN'
 config.headers['countryid'] = '105'
 config.headers['AppVersion'] = packageJson.version;
 const accessToken = localStorage.getItem('ampleAccessToken')
 if (accessToken) {
  config.headers['Authorization'] = accessToken
 }
 return config
})
export const getAmpleStoreDetails = () => {
 return { GTMID: apiConfig.GTMID, userid: apiConfig.userid, pslid: apiConfig.pslid, callbackurl: apiConfig.callbackurl }
}